import React, { ReactNode } from 'react';

import { Text } from '@xyz-school/xyz-react-frontend';

import styles from './DefinitionList.scss';

type Props = {
    children: ReactNode;
};

const DefinitionListLabel = ({ children }: Props) => {
    return (
        <Text color="label" size="small" className={styles.label}>
            {children}
        </Text>
    );
};

export default DefinitionListLabel;
